import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PdfViewerContext } from "../../contexts/PdfViewer/InterceptorContext";
import { PdfViewer } from "../../components/organisms/PdfViewer";

export function Recibo() {
  const navigate = useNavigate();
  const { pdf } = React.useContext(PdfViewerContext);

  useEffect(() => {
    if (!pdf) {
      navigate("/reservation");
    }
  }, [pdf, navigate]);

  return pdf ? <PdfViewer /> : null;
}
